/* eslint-disable restrict-imports/restrict-imports */
import { Tooltip, Typography, Chip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ISlackChannelProps } from './SlackChannel';

const SlackChannelInfo = (props: ISlackChannelProps) => {
  return (
    <>
      <div className="current-channel-container">
        <Tooltip
          title={
            <>
              <Typography variant="subtitle2" color="inherit">
                Permission Group:
              </Typography>
              <Chip
                label={props.permissionGroup ?? 'No permission group info available'}
                size="small"
              ></Chip>
              <Typography color="inherit" variant="subtitle2">
                Users in channel:{' '}
              </Typography>
              <Chip
                label={props.channel?.memberCount ?? 'No members info available'}
                size="small"
              ></Chip>
            </>
          }
          placement="top"
        >
          <FontAwesomeIcon icon="info-circle" style={{ color: '#9CA3AF', fontSize: '20px' }} />
        </Tooltip>
      </div>
      <style jsx>{`
        .current-channel-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelInfo;
